import shortid from 'shortid'
import * as api from '../../requests'
import {
  SET_ITEMS,
  SET_LOADING,
  SET_ERROR,
  SET_LAST_REQUEST_ID,
  SET_FILTERS,
  RESET_FILTERS
} from './MiscellaneousMyWorkQueueReducer'

export const setMiscWqItems = (items, template) => ({
  type: SET_ITEMS,
  items,
  template,
})

export const setMiscWqLoading = (loading) => ({
  type: SET_LOADING,
  loading,
})

export const setMiscWqError = (error) => ({
  type: SET_ERROR,
  error,
})

export const setMiscWqLastRequestId = (requestId) => ({
  type: SET_LAST_REQUEST_ID,
  requestId,
})

export const setMiscWqFilters = (filters) => ({
  type: SET_FILTERS,
  filters,
})

export const resetMiscWqFilters = () => ({
  type: RESET_FILTERS,
})

export const fetchMiscWorkQueueItems = (moduleId) => (dispatch, getState) => {
  dispatch(setMiscWqLoading(true))
  dispatch(setMiscWqError(null))

  const { filters } = getState().miscWorkQueue
  const requestId = shortid.generate()
  dispatch(setMiscWqLastRequestId(requestId))

  const parameters = {}
  if (filters.search) parameters.search = filters.search
  if (filters.status) parameters.status = filters.status
  if (filters.submissionStartDate) parameters.submissionStartDate = filters.submissionStartDate
  if (filters.submissionEndDate) parameters.submissionEndDate = filters.submissionEndDate

  api.GET_MISC_RECORDS_WORK_QUEUE_ITEMS(
    moduleId,
    parameters,
    requestId,
    (data, props = {}) => {
      if (getState().miscWorkQueue.lastRequestId === props.requestId) {
        dispatch(setMiscWqItems(data.Items, data.Template))
        dispatch(setMiscWqLoading(false))
      }
    },
    () => {
      dispatch(setMiscWqLoading(false))
      dispatch(setMiscWqError(true))
    }
  )
}